import { ComplexValue, Entity } from "app/types-shared";
import { DateFormat } from "ui/common/types";
import isEqual from 'lodash/isequal';
import { FavouriteDataColumn } from "app/components/favourite-layout/favourite/common/favourite-interfaces";

export const CASE_TABLE_VIEW_DATE_FORMAT: Intl.DateTimeFormatOptions = {
    year: DateFormat.Numeric,
    month: DateFormat.DoubleDigit,
    day:  DateFormat.DoubleDigit,
    hour: DateFormat.DoubleDigit,
    minute: DateFormat.DoubleDigit
};

const findRowEntity = (rowEntities: Entity[], column: Partial<FavouriteDataColumn>): Entity | undefined => {
  if (column.entityTypePath?.length === 1 && column.entityTypePath[0] === 'TblTrans') {
    return rowEntities?.[0];
  }
  return rowEntities.find(field => {
    const fieldEntityPath = field.id.map(entityPath => Object.keys(entityPath)[0]?.toLowerCase());
    return isEqual(fieldEntityPath, column.entityTypePath.map(path => path.toLowerCase()));
  });
};

export const getColumnData = (rowEntities: Entity[], column: Partial<FavouriteDataColumn>): ComplexValue<number>[] => {
  const entity = findRowEntity(rowEntities, column);
  return entity?.[column.columnName] as ComplexValue<number>[] || [];
};

export const getPrimaryKey = (rowEntities: Entity[], column: Partial<FavouriteDataColumn>): number | null => {
  const entity = findRowEntity(rowEntities, column);
  return entity?.primaryKey?.value as number || null;
};
